import { VehicleType } from './vehicle-type.enum';

export type Vehicle = {
  id: number;
  plateCode: string;
  typeId: VehicleType;
  vehicleTypeId?: number;
};


export type VehicleTypeOption = {
  id: number;
  typeId: number;
  name: string;
};


export enum VehicleTypesEnum {
  AUTO = 2,
  MOTO = 1,
  CAMPER = 3,
  ROULOTTE = 4,
}
